// @ts-check
import React from 'react';
import { Box, Title, useTheme } from '../../../pdf-design-system';
import Flex from '../../../pdf-design-system/Base/Flex';
import { usePage } from '../../../pdf-design-system/Base/PageLayout/Page';
import { ThemeProvider } from '../../../pdf-design-system/useTheme';
import VieVinumLine from '../components/VieVinumLine';
import useRoom from '../useRoom';
import VievinumLogo from '../VieVinumLogo';
import theme from './vievinumTheme';
// import VieVinumStencil from '../Stencil/VieVinumStencil';

/** @param {{children?: React.ReactNode}} props */
export default function StaticCatalogPageContent({ children }) {
  const room = useRoom();
  const { alignment } = usePage();
  return (
    <ThemeProvider
      theme={{ ...theme, colors: { ...theme.colors, ...room?.colors } }}
    >
      {/* <VieVinumStencil
        fixed
        style={[
          { opacity: 0.5 },
          alignment === 'left' ? { left: 0 } : { right: 0 },
        ]}
      /> */}
      {children}
      <VieVinumFooter
        fixed
        style={[
          { position: 'absolute', bottom: '2.7mm', left: '9mm', right: '9mm' },
          alignment === 'left'
            ? { paddingRight: '6mm' }
            : { paddingLeft: '6mm' },
        ]}
      />
    </ThemeProvider>
  );
}

function VieVinumFooter({ ...rest }) {
  const { alignment } = usePage();
  const room = useRoom();
  const { theme } = useTheme();
  return (
    <Box {...rest}>
      <VieVinumLine width="100%" style={{ marginBottom: '0.6mm' }} />
      <Flex
        direction={alignment === 'left' ? 'row' : 'row-reverse'}
        style={{ justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Title style={{ color: theme.colors.primary }}>{room?.name}</Title>
        <VievinumLogo color="#000" style={{ width: '9mm', height: '8mm' }} />
      </Flex>
    </Box>
  );
}
